export default __webpack_public_path__ + "assets/images/change-cards-icon.8e20e438b20140100cafbe4e5754a607.svg";